/**
 * @file 
 *
 */
'use strict';

/**
 * @classname FormAppendOptionDayView
 * @classdesc 
 */
export default class FormAppendOptionDayView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormAppendOptionDayView.constructor');
		this._$e = $e;
		this.appendOption();
	};

	appendOption() {
		console.log('FormAppendOptionDayView.appendOption');
		for(let i = 1; i <= 31; i++) {
			this._$e.append(`<option value="${i}">${i}</option>`);
		}
	}
}
